import defaultLocationSearches from './configDefaultLocationSearches';

//////////////////////////////////////////////////////
// Configurations related to location search        //
//////////////////////////////////////////////////////

// The location search input can be configured to show default
// searches when the user focuses on the input and hasn't yet typed
// anything. This reduces typing.
export const search = {
  // This affects location search.
  // These "default locations" can be edited in the
  // `configDefaultLocationSearches.js` file.
  defaults: defaultLocationSearches || [],

  // Should search results be ordered by distance to origin.
  sortSearchByDistance: false,
};

// Fuzzy location config (kept for compatibility with existing data)
export const fuzzy = {
  enabled: false,
  offset: 500,
  defaultZoomLevel: 13,
  circleColor: '#c0392b',
};
